import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Mail, Lock, User, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './AuthModal.css';

const AuthModal = ({ isOpen, onClose }) => {
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const { login, signup } = useAuth();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isLogin) {
            if (login(email, password)) onClose();
        } else {
            if (signup(name, email, password)) onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <AnimatePresence>
            <div className="auth-modal-overlay" onClick={onClose}>
                <motion.div
                    className="auth-modal-content"
                    initial={{ opacity: 0, scale: 0.9, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.9, y: 20 }}
                    onClick={e => e.stopPropagation()}
                >
                    <button className="close-modal" onClick={onClose}>
                        <X size={24} />
                    </button>

                    <div className="auth-header">
                        <div className="auth-logo">SH</div>
                        <h2>{isLogin ? 'Bon retour !' : 'Rejoindre Sugar Hut'}</h2>
                        <p>{isLogin ? 'Connectez-vous pour commander vos burgers préférés' : 'Créez un compte pour cumuler des points de fidélité'}</p>
                    </div>

                    <form className="auth-form" onSubmit={handleSubmit}>
                        {!isLogin && (
                            <div className="input-group">
                                <label><User size={16} /> Nom complet</label>
                                <input
                                    type="text"
                                    placeholder="Jean Dupont"
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                    required
                                />
                            </div>
                        )}
                        <div className="input-group">
                            <label><Mail size={16} /> Adresse Email</label>
                            <input
                                type="email"
                                placeholder="votre@email.com"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="input-group">
                            <label><Lock size={16} /> Mot de passe</label>
                            <input
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        <button type="submit" className="auth-submit">
                            {isLogin ? 'Se connecter' : "S'inscrire"}
                            <ArrowRight size={18} />
                        </button>
                    </form>

                    <div className="auth-footer">
                        {isLogin ? (
                            <p>Pas encore de compte ? <button onClick={() => setIsLogin(false)}>S'inscrire</button></p>
                        ) : (
                            <p>Déjà un compte ? <button onClick={() => setIsLogin(true)}>Se connecter</button></p>
                        )}
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
};

export default AuthModal;
